import React, { PureComponent } from 'react';
import { Icon, InfiniteTable, DLMenu } from 'appSrc/components/UI';
import TextTruncate from 'react-text-truncate';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class ContentTable extends PureComponent {
    render() {
        const { content } = this.props;

        return (
            <div>
                <InfiniteTable
                loadMore={ this.props.loadMore }
                elementHeight={ 70 }>
                    { this.arrayTableRows( content ) }
                </InfiniteTable>
            </div>
        );
    }


    arrayTableRows = ( content ) => {
        var rows = content.map( ( content ) => {
            var author = content.author || {};
            var individualSlug = `/admin/content/${ content.id }`;
            return (
                <InfiniteTable.Row key={ content.id } className='dl-table-body'>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }></Link>
                        <TextTruncate text={ content.title }
                        line={ 2 } />
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }></Link>
                        { ( content.content_type || {} ).name }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }></Link>
                        { author.displayName }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }></Link>
                        { content.categories.map( category => ( category || {} ).name ).join( ', ' ) }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Remove'
                            onClick={ () => {
                                this.props.deleteConnection( content );
                            } }/>
                        </DLMenu>
                    </InfiniteTable.Cell>
                </InfiniteTable.Row>
            );
        } );
        rows.unshift(
            (
                <InfiniteTable.Row key='-1' className='dl-table-head'>
                    <InfiniteTable.Cell>
                        Title
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        TYPE
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        USER
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        CATEGORY
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>ACTIONS</InfiniteTable.Cell>
                </InfiniteTable.Row>
            )
        );

        return rows;
    }
}
ContentTable.defaultProps = {
    onArticleUpdated: ()=>{},
    deleteConnection: ()=>{},
};

export default ContentTable;
